var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h2", [_vm._v("Delete/Scramble User Accounts")]),
      _vm._v(" "),
      _vm.hasScramblePermission
        ? [
            _c("div", { staticClass: "well" }, [
              _c(
                "form",
                {
                  staticClass: "form",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.uploadCSV.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "csvToScramble" } }, [
                      _vm._v("CSV of Users")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      ref: "fileInput",
                      attrs: {
                        type: "file",
                        accept: "text/csv",
                        id: "csvToScramble"
                      },
                      on: { change: _vm.fileChanged }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "help-block" }, [
                      _vm._v(
                        "Expects a CSV provided by the Expired/Inactive Users Export - mandatory columns are uuid, email, and domain_uuid."
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "scrambleNotes" } }, [
                      _vm._v("Notes (required)")
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csvNotes,
                          expression: "csvNotes"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        name: "scrambleNotes",
                        id: "scrambleNotes",
                        cols: "30",
                        rows: "3"
                      },
                      domProps: { value: _vm.csvNotes },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.csvNotes = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "help-block" }, [
                      _vm._v(
                        "Description of the contents of CSV (e.g. date cut-off info, enterprise vs. trial users, etc)"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.uploadErr
                    ? _c(
                        "alert",
                        {
                          attrs: { type: "danger", dismissible: "" },
                          on: {
                            dismissed: function($event) {
                              _vm.uploadErr = ""
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.uploadErr))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.uploadSuccess
                    ? _c(
                        "alert",
                        {
                          attrs: { type: "success", dismissible: "" },
                          on: {
                            dismissed: function($event) {
                              _vm.uploadSuccess = ""
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.uploadSuccess))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "submit",
                        disabled: !_vm.csvFile || !_vm.csvNotes || _vm.uploading
                      }
                    },
                    [
                      _vm.uploading
                        ? _c("i", {
                            staticClass: "fa fa-circle-o-notch fa-spin"
                          })
                        : _vm._e(),
                      _vm._v("\n          Scramble Users in CSV\n        ")
                    ]
                  )
                ],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("h3", { staticClass: "light" }, [
        _vm._v("Scramble Records\n    "),
        _c(
          "button",
          {
            staticClass: "btn btn-default",
            attrs: { disabled: _vm.fetchingRecords },
            on: { click: _vm.getRecords }
          },
          [
            _vm.fetchingRecords
              ? _c("i", {
                  staticClass: "fa fa-circle-o-notch fa-spin text-muted"
                })
              : _vm._e(),
            _vm._v("\n      Refresh\n    ")
          ]
        )
      ]),
      _vm._v(" "),
      !_vm.fetchingRecords && _vm.records.length === 0
        ? _c("alert", { attrs: { type: "info" } }, [
            _vm._v("No scramble records found")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.recordsErr
        ? _c(
            "alert",
            {
              attrs: { type: "danger", dismissible: "" },
              on: {
                dismissed: function($event) {
                  _vm.recordsErr = ""
                }
              }
            },
            [_vm._v(_vm._s(_vm.recordsErr))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.records.length > 0
        ? _c("v-client-table", {
            ref: "scrambleRecordsTable",
            attrs: {
              data: _vm.recordRows,
              columns: _vm.tableInfo.columns,
              options: _vm.tableInfo.options
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "filename",
                  fn: function(props) {
                    return [
                      _vm._v(
                        "\n      " + _vm._s(props.row.filename) + "\n      "
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("p", [
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(props.row.uuid))
                        ])
                      ]),
                      _vm._v(" "),
                      props.row.created_by || props.row.notes
                        ? _c("p", [
                            _vm._v("\n        " + _vm._s(props.row.created_by)),
                            _c("br"),
                            _vm._v(
                              "\n        " +
                                _vm._s(props.row.notes) +
                                "\n      "
                            )
                          ])
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "timestamp",
                  fn: function(props) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            new Date(props.row.started_at).toLocaleString()
                          ) +
                          "\n      "
                      ),
                      _c("br"),
                      _vm._v(" "),
                      props.row.duration
                        ? _c("span", { staticClass: "text-muted" }, [
                            _c("i", { staticClass: "fa fa-clock-o" }),
                            _vm._v(" " + _vm._s(props.row.duration))
                          ])
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "mc_batch_id",
                  fn: function(props) {
                    return [
                      props.row.mc_batch_id
                        ? _c(
                            "a",
                            {
                              attrs: { role: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.showMailchimpStatus(
                                    props.row.uuid,
                                    props.row.mc_batch_id
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(props.row.mc_batch_id))]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "userstore_delete_op_id",
                  fn: function(props) {
                    return [
                      props.row.userstore_delete_op_id
                        ? _c(
                            "a",
                            {
                              attrs: { role: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.showUserstoreDeleteOp(
                                    props.row.uuid,
                                    props.row.userstore_delete_op_id
                                  )
                                }
                              }
                            },
                            [_vm._v("View status")]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "status",
                  fn: function(props) {
                    return [
                      props.row.status === "Finished"
                        ? _c("small", { staticClass: "text-success" }, [
                            _c("i", { staticClass: "fa fa-check-circle" }),
                            _vm._v(" Completed\n      ")
                          ])
                        : _c("small", [_vm._v(_vm._s(props.row.status))]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-xs",
                          attrs: {
                            "aria-label": "refresh status",
                            disabled: _vm.fetchingDetail[props.row.uuid]
                          },
                          on: {
                            click: function($event) {
                              return _vm.getRecordDetail(props.row.uuid)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-refresh",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: { role: "button" },
                          on: {
                            click: function($event) {
                              return _vm.displayModal("Logs", props.row.log)
                            }
                          }
                        },
                        [_vm._v("View log")]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      props.row.errors && props.row.errors.length > 0
                        ? _c(
                            "a",
                            {
                              attrs: { role: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.displayModal(
                                    "Errors",
                                    props.row.errors
                                  )
                                }
                              }
                            },
                            [_vm._v("View errors")]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ],
              null,
              false,
              3365677480
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { title: _vm.modalTitle, footer: false },
          on: {
            hide: function($event) {
              _vm.showDetailModal = false
            }
          },
          model: {
            value: _vm.showDetailModal,
            callback: function($$v) {
              _vm.showDetailModal = $$v
            },
            expression: "showDetailModal"
          }
        },
        [_c("pre", [_vm._v(_vm._s(JSON.stringify(_vm.modalJSON, "", 2)))])]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }